import { Radio, RadioGroup, Stack } from "@chakra-ui/react";
import { FieldComponentProps } from "./types";

export function FieldBoolean(props: FieldComponentProps) {
  return (
    <RadioGroup
      id={props.id}
      onChange={(value) => {
        props.updateValue({ label: props.label, value });
      }}
      value={props.value}
    >
      <Stack direction="row" spacing={6}>
        <Radio isInvalid={props.isInvalid} value="Ja">
          Ja
        </Radio>
        <Radio isInvalid={props.isInvalid} value="Nein">
          Nein
        </Radio>
      </Stack>
    </RadioGroup>
  );
}
